import { Observable, catchError, EMPTY, from, ignoreElements, mergeMap } from 'rxjs';
import { ofType } from 'src/core/engine/rxjs/ofType';
import { ApolloClient } from '@apollo/client';
import { Actions } from 'src/core/state/user';
import { Deps } from 'src/types/global-types';

/**
 * Wipe customer-scoped Apollo data on sign-out / reset so the next account
 * cannot see the previous customer's cache (e.g. orders).
 *
 * Sign-in is handled in userSignedInReaction so this does not cancel the
 * in-flight cart-id swap.
 */
export function clearApolloStoreOnAuthChange(action$: Observable<any>, _state$: Observable<any>, deps: Deps) {
    return action$.pipe(
        ofType<Actions>('User.SignOut', 'User.Reset'),
        mergeMap(() => clearApolloStore(deps)),
    );
}

export function clearApolloStore(deps: Deps) {
    if (!deps.client) {
        return EMPTY;
    }

    return from((deps.client as ApolloClient<any>).clearStore()).pipe(
        ignoreElements(),
        catchError(() => EMPTY),
    );
}
